import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { ZealClientError } from "../../../AbstractApiClient/ZealClientError";
import {
  IDeleteDepartmentResponseData,
  IDeleteDepartmentArgs,
} from "./deleteDepartment.schema";
import { ZealApiSuccessResponse } from "@zeal/common";

type SuccessResponse = ZealApiSuccessResponse<IDeleteDepartmentResponseData>;

export const deleteDepartment = (axios: IAxiosInstance) => {
  return async (params: IDeleteDepartmentArgs) => {
    try {
      const { companyID, departmentID } = params;
      const response = await axios.noRetry.delete<SuccessResponse>(
        `/api/departments`,
        { params: { companyID, departmentID } }
      );
      return response?.data?.data;
    } catch (e) {
      throw new ZealClientError(e);
    }
  };
};
